import React, { useState } from "react";
import {
  TextField,
  MenuItem,
  Button,
  Typography,
  Box,
  Paper,
  IconButton,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialSelect from "../../../../components/MasterSelect";
import MaterialButton from "../../../../components/MaterialButton";
import Grid from "@mui/material/Grid2";

const QuestionsAdd = ({ question, setQuestion }) => {
  const [editIndex, setEditIndex] = useState(null);

  const selectoption = [
    { label: "True/False", value: "TrueFalse" },
    { label: "MCQ", value: "MCQ" },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "correctansweroption") {
  setQuestion((prev) => ({
    ...prev,
    correctansweroption: value,
  }));
}
     else {
      setQuestion((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleChangequestiontype = (selectevent) => {
    setQuestion((prev) => ({
      ...prev,
      questiontype: selectevent,
    }));
  };

  const clearForm = () => {
    setQuestion((prev) => ({
      ...prev,
      questiontype: "",
      questiontext: "",
      option1: "",
      option2: "",
      option3: "",
      option4: "",
      correctansweroption: "",
      markinput: "",
    }));
    setEditIndex(null);
  };

  const handleAddOrUpdateQuestion = () => {
    const { questionlist, ...newQuestion } = question;

    if (!newQuestion.correctansweroption || !newQuestion.questiontext.trim()) {
      alert("Please enter the question and select the correct answer.");
      return;
    }

    if (question.questiontype?.value === "MCQ") {
      if (
        !newQuestion.option1.trim() ||
        !newQuestion.option2.trim() ||
        !newQuestion.option3.trim() ||
        !newQuestion.option4.trim()
      ) {
        alert("All four options are required for MCQ.");
        return;
      }
    }

    if (question.questiontype.value === "TrueFalse") {
      newQuestion.option1 = "True";
      newQuestion.option2 = "False";
      newQuestion.option3 = "";
      newQuestion.option4 = "";
    }

    if (editIndex !== null) {
      const updatedList = [...question.questionlist];
      updatedList[editIndex] = newQuestion;
      setQuestion((prev) => ({
        ...prev,
        questionlist: updatedList,
      }));
    } else {
      setQuestion((prev) => ({
        ...prev,
        questionlist: [...prev.questionlist, newQuestion],
      }));
    }

    clearForm();
  };

  const handleEdit = (index) => {
    const selected = question.questionlist[index];
    setQuestion((prev) => ({
      ...prev,
      ...selected,
    }));
    setEditIndex(index);
  };

  const handleDelete = (index) => {
    const updatedList = question.questionlist.filter((_, i) => i !== index);
    setQuestion((prev) => ({
      ...prev,
      questionlist: updatedList,
    }));
    if (editIndex === index) clearForm();
  };

  const renderOptions = () => {
    if (question.questiontype?.value === "TrueFalse") {
      return (
        <FormControl component="fieldset">
          <MaterialTypography sx={{ marginTop: "1%", fontSize: "16px" }} component="label">
            Select Correct Answer <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
          <RadioGroup
            name="correctansweroption"
            value={question.correctansweroption}
            onChange={handleChange}
          >
            <FormControlLabel value="True" control={<Radio />} label="True" />
            <FormControlLabel value="False" control={<Radio />} label="False" />
          </RadioGroup>
        </FormControl>
      );
    }

    return (
      <FormControl component="fieldset">
        <MaterialTypography sx={{ marginTop: "1%", marginBottom: "1%", fontSize: "16px" }} component="label">
          Options (Select Correct Answer) <span style={{ color: "red" }}>*</span>
        </MaterialTypography>
        <RadioGroup
          name="correctansweroption"
          value={question.correctansweroption}
          onChange={handleChange}
        >
          {[1, 2, 3, 4].map((num) => {
            const optKey = `option${num}`;
            const optVal = question[optKey];
            return (
              <Grid container alignItems="baseline" key={optKey} sx={{ mb: 1 }}>
                <Grid size={{ xs: 1, sm: 1 }}>
                  <FormControlLabel
                    value={optKey}
                    control={<Radio />}
                    label=""
                  />
                </Grid>
                <Grid size={{ xs: 11, sm: 11 }}>
                  <MaterialInput
                    fullWidth
                    label={`Option ${num}`}
                    name={optKey}
                    value={optVal}
                    onChange={handleChange}
                  />
                </Grid>
              </Grid>
            );
          })}
        </RadioGroup>
      </FormControl>
    );
  };

  const checkAllFields = () => {
    return (
      question.questiontype?.value &&
      question.questiontext &&
      question.correctansweroption &&
      question.markinput
    );
  };

  return (
    <Box>
      <MaterialTypography sx={{ marginTop: "1%", fontSize: "16px" }} component="label">
        {editIndex !== null ? "Edit Question" : "Create a Question"}
      </MaterialTypography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 6, sm: 6 }}>
          <MaterialTypography component="label" variant="caption" fontWeight="bold">
            Select Type <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
          <MaterialSelect
            label="Question Type"
            name="questiontype"
            select
            fullWidth
            value={question.questiontype}
            onChange={handleChangequestiontype}
            options={selectoption}
          />
        </Grid>

        <Grid size={{ xs: 6, sm: 6 }}>
          <MaterialTypography component="label" variant="caption" fontWeight="bold">
            Question <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
          <MaterialInput
            label="Question Text"
            name="questiontext"
            fullWidth
            multiline
            rows={5}
            value={question.questiontext}
            onChange={handleChange}
          />
        </Grid>

        <Grid size={{ xs: 6, sm: 6 }}>{renderOptions()}</Grid>

        <Grid size={{ xs: 12, sm: 12 }} sx={{ justifyContent: "end" }}>
          <MaterialTypography component="label" variant="caption" fontWeight="bold">
            Mark <span style={{ color: "red" }}>*</span>
          </MaterialTypography>
          <MaterialInput
            label="Marks"
            name="markinput"
            type="text"
            fullWidth
            value={question.markinput}
            onChange={(event) => {
              const value = event.target.value;
              if (/^\d{0,10}$/.test(value)) {
                handleChange(event);
              }
            }}
            onKeyDown={(event) => {
              const allowedKeys = [
                "Backspace",
                "Delete",
                "ArrowLeft",
                "ArrowRight",
                "Tab",
              ];
              const isNumericKey = /^[0-9]$/.test(event.key);
              if (
                (!isNumericKey && !allowedKeys.includes(event.key)) ||
                (question.markinput && question.markinput >= 3 && isNumericKey)
              ) {
                event.preventDefault();
              }
            }}
          />
        </Grid>

        <Grid size={{ xs: 6, sm: 6 }}>
          <MaterialButton
            variant="gradient"
            color="dark"
            disabled={!checkAllFields()}
            onClick={handleAddOrUpdateQuestion}
          >
            {editIndex !== null ? "Update Question" : "Add Question"}
          </MaterialButton>
          {editIndex !== null && (
            <MaterialButton onClick={clearForm} sx={{ ml: 2 }} variant="gradient" color="dark">
              Cancel
            </MaterialButton>
          )}
        </Grid>

        <Grid size={{ xs: 12, sm: 12 }}>
          <MaterialTypography component="label" sx={{ fontSize: "16px" }}>
            Question List
          </MaterialTypography>
          <div style={{ maxHeight: "400px", overflowY: "auto" }}>
            {question.questionlist.map((q, i) => (
              <Paper key={i} sx={{ p: 2, my: 1, position: "relative" }}>
                <MaterialTypography variant="body1">
                  {i + 1}. {q.questiontext}
                </MaterialTypography>
                <ul style={{ marginLeft: "2%" }}>
                  {[q.option1, q.option2, q.option3, q.option4]
                    .filter(Boolean)
                    .map((opt, idx) => (
                      <li key={idx}>{opt}</li>
                    ))}
                </ul>
                <MaterialTypography variant="body2" color="secondary">
                  Correct Answer:{" "}
                  {q[q.correctansweroption] || q.correctansweroption} | Marks:{" "}
                  {q.markinput}
                </MaterialTypography>
                <Box sx={{ position: "absolute", top: 8, right: 8 }}>
                  <IconButton onClick={() => handleEdit(i)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton onClick={() => handleDelete(i)} color="error">
                    <DeleteIcon />
                  </IconButton>
                </Box>
              </Paper>
            ))}
          </div>
        </Grid>
      </Grid>
    </Box>
  );
};

export default QuestionsAdd;
